import { styled } from "@mui/material/styles";

export const LoginContainer = styled("div")(({ theme }) => ({
  position: 'relative',
  marginTop: theme.space._1000,
  width: "100%",
  maxWidth: "1440px",
  marginLeft: "auto",
  marginRight: "auto",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: theme.space._700,
  paddingBottom: "12.5rem"
}));

export const LoginOrRegisterContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: theme.space._600,
  width: "min-content",
  alignSelf: "stretch",

  "@media (max-width: 600px)": {
    padding: `0 ${theme.space._400}`,
    width: "100%",
  },
}));


